import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations for Brazilian Portuguese and Spanish (Paraguay)
const translations = {
  'pt-BR': {
    // Navigation
    home: 'Início',
    products: 'Produtos',
    categories: 'Categorias',
    about: 'Sobre Nós',
    contact: 'Contato',
    cart: 'Carrinho',
    account: 'Minha Conta',
    login: 'Entrar',
    register: 'Cadastrar',
    logout: 'Sair',
    search: 'Buscar',
    searchPlaceholder: 'Buscar produtos, marcas, categorias...',
    
    // Header
    followUs: 'Siga-nos',
    
    // Hero Section
    heroTitle: 'Descubra produtos incríveis',
    heroSubtitle: 'Compre as últimas tendências e ofertas exclusivas em um só lugar.',
    shopNow: 'Comprar agora',
    exploreCategories: 'Explorar Categorias',
    
    // Categories
    allCategories: 'Ver todas as categorias',
    showAllCategories: 'Ver todas as categorias',
    exploreSelection: 'Explore a seleção',
    viewProducts: 'Ver produtos',
    
    // Products
    offersOfTheDay: 'Ofertas do Dia',
    takeAdvantage: 'Aproveite os melhores descontos de hoje!',
    mostViewed: 'Mais Vistos',
    trendingNow: 'Esses produtos estão em alta agora',
    viewAll: 'Ver Tudo',
    viewAllProducts: 'Ver Todos os Produtos',
    topBrands: 'Marcas Destacadas',
    showAll: 'Ver todas',
    showAllBrands: 'Ver todas as marcas',
    bestSellers: 'Mais Vendidos',
    discoverBuying: 'Descubra o que estão comprando agora',
    featuredProducts: 'Produtos em Destaque',
    popularProducts: 'Produtos Populares',
    specialSelection: 'Uma seleção especial para você',
    discoverPopular: 'Descubra nossos produtos mais escolhidos',
    mostRelevant: 'Mais Relevante',
    lowestPrice: 'Menor Preço',
    highestPrice: 'Maior Preço',
    newest: 'Mais Recente',
    newArrivals: 'Novidades',
    addToCart: 'Adicionar ao Carrinho',
    buyNow: 'Comprar Agora',
    inStock: 'Em estoque',
    outOfStock: 'Esgotado',
    price: 'Preço',
    quantity: 'Quantidade',
    color: 'Cor',
    size: 'Tamanho',
    description: 'Descrição',
    specifications: 'Especificações',
    availability: 'Disponibilidade',
    category: 'Categoria',
    noSpecifications: 'Nenhuma especificação disponível',
    reviews: 'Avaliações',
    
    // Cart
    myCart: 'Meu Carrinho',
    emptyCart: 'Seu carrinho está vazio',
    continueShopping: 'Continuar Comprando',
    checkout: 'Finalizar Compra',
    subtotal: 'Subtotal',
    shipping: 'Frete',
    total: 'Total',
    removeItem: 'Remover',
    updateQuantity: 'Atualizar Quantidade',
    
    // Checkout
    shippingInfo: 'Informações de Entrega',
    fullName: 'Nome Completo',
    email: 'E-mail',
    phone: 'Telefone',
    address: 'Endereço',
    city: 'Cidade',
    state: 'Estado',
    country: 'País',
    zipCode: 'CEP',
    paymentMethod: 'Forma de Pagamento',
    placeOrder: 'Fazer Pedido',
    
    // Account
    myAccount: 'Minha Conta',
    myOrders: 'Meus Pedidos',
    wishlist: 'Lista de Desejos',
    favorites: 'Favoritos',
    notifications: 'Notificações',
    settings: 'Configurações',
    orderHistory: 'Histórico de Pedidos',
    
    // Auth
    emailAddress: 'Endereço de E-mail',
    password: 'Senha',
    confirmPassword: 'Confirmar Senha',
    forgotPassword: 'Esqueceu a senha?',
    noAccount: 'Não tem uma conta?',
    haveAccount: 'Já tem uma conta?',
    createAccount: 'Criar Conta',
    signIn: 'Entrar',
    signUp: 'Cadastrar',
    processing: 'Processando...',
    
    // Contact
    contactUs: 'Fale Conosco',
    ourTeam: 'Nossa Equipe',
    contactDirectly: 'Entre em contato diretamente com quem pode ajudá-lo melhor',
    generalManager: 'Gerente Geral',
    customerService: 'Atendimento ao Cliente',
    salesAdvisory: 'Vendas e Assessoria',
    writeWhatsApp: 'Enviar mensagem no WhatsApp',
    contactInfo: 'Informações de Contato',
    sendMessage: 'Enviar Mensagem',
    yourName: 'Seu Nome',
    yourEmail: 'Seu E-mail',
    subject: 'Assunto',
    message: 'Mensagem',
    send: 'Enviar',
    
    // Vendedores
    vendedores: 'Vendedores',
    vendedoresDesc: 'Entre em contato com nossos vendedores para um atendimento personalizado',
    messageOnWhatsApp: 'Mensagem no WhatsApp',

    // About
    aboutUs: 'Sobre Nós',
    ourMission: 'Nossa Missão',
    ourValues: 'Nossos Valores',
    ourHistory: 'Nossa História',
    whyChooseUs: 'Por que escolher a ASMAR SHOP?',
    bestOption: 'Somos sua melhor opção em produtos e equipamentos',
    fastDelivery: 'Entrega Rápida',
    fastDeliveryDesc: 'Entregamos em todo o Brasil com rapidez e segurança garantida',
    qualityGuarantee: 'Garantia de Qualidade',
    qualityGuaranteeDesc: 'Produtos originais com garantia e suporte oficial',
    personalizedService: 'Atendimento Personalizado',
    personalizedServiceDesc: 'Assessoria especializada via WhatsApp quando você precisar',
    
    // Footer
    navigation: 'Navegação',
    newsletter: 'Newsletter',
    newsletterText: 'Receba ofertas exclusivas e novidades primeiro.',
    yourEmailAddress: 'Seu endereço de e-mail',
    subscribeSuccess: 'Inscrição realizada com sucesso!',
    noSpam: 'Prometemos não enviar spam!',
    privacy: 'Privacidade',
    terms: 'Termos',
    paymentMethods: 'Formas de Pagamento',
    allRightsReserved: 'Todos os direitos reservados.',
    deliveryInfo: 'Informações de Entrega',
    paraguayOnlyDelivery: 'ENTREGAS SOMENTE NO PARAGUAY',
    brazilPickupNotice: 'Entregas somente no Paraguay. Para Brasil e região, deve ser retirado na loja.',
    
    // FAQ
    faq: 'Perguntas Frequentes',
    
    // Features
    qualityGuarantee: 'Garantia de Qualidade',
    qualityGuaranteeDesc: 'Produtos originais com garantia e suporte oficial',
    securePayment: 'Pagamento Seguro',
    securePaymentDesc: 'Compre com total segurança e proteção',
    bestPrices: 'Melhores Preços',
    bestPricesDesc: 'Os melhores preços do Brasil e Paraguai',
    support24: 'Suporte 24/7',
    support24Desc: 'Atendimento sempre disponível para você',
    fastDelivery: 'Entrega Rápida',
    fastDeliveryDesc: 'Frete será decidido no checkout',
    easyReturns: 'Devolução Fácil',
    easyReturnsDesc: 'Até 30 dias para devolver',
    
    // General
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    seeAll: 'Ver tudo',
    seeMore: 'Ver mais',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    close: 'Fechar',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    filter: 'Filtrar',
    sort: 'Ordenar',
    apply: 'Aplicar',
    clear: 'Limpar',
    clearAll: 'Limpar tudo',
    noResults: 'Nenhum resultado encontrado',
    continue: 'Continuar',
    
    // Search
    searchProducts: 'Buscar Produtos',
    productsFound: 'produtos encontrados',
    results: 'resultados',
    all: 'Todos',
    noResultsFor: 'Não foram encontrados resultados para',
    noProductsFound: 'Nenhum produto encontrado',
    tryAdjustingFilters: 'Tente ajustar os filtros ou buscar outro termo',
    errorSearching: 'Erro ao buscar',
    errorAddingToCart: 'Erro ao adicionar ao carrinho',
    or: 'ou',
    items: 'itens',
    
    // Cart Additional
    cartItems: 'Itens do Carrinho',
    orderSummary: 'Resumo do Pedido',

    itemRemoved: 'Item removido',
    deleteError: 'Erro ao remover',
    updateError: 'Erro ao atualizar',
    addItemsToCart: 'Adicione produtos ao seu carrinho',
    enterFullName: 'Digite seu nome completo',
    enterEmail: 'Digite seu e-mail',
    enterPhone: 'Digite seu telefone',
    enterAddress: 'Digite seu endereço',
    enterCity: 'Digite sua cidade',
    enterState: 'Digite seu estado',
    loginRequired: 'Login Necessário',
    loginToCheckout: 'Faça login para continuar',
    loginToAddWishlist: 'Faça login para adicionar à lista de desejos.',
    requiredFields: 'Campos Obrigatórios',
    fillAllFields: 'Preencha todos os campos',
    orderPlaced: 'Pedido Realizado!',
    orderError: 'Erro ao criar pedido',
    orderViaWhatsApp: 'Pedir via WhatsApp',
    proceedToPayment: 'Ir para Pagamento',
    order: 'Pedido',
    customerData: 'Dados do Cliente',
    shippingAddress: 'Endereço de Entrega',
    orderSuccess: 'Pedido criado com sucesso!',
    
    // Products Page (additional keys not already defined)
    filters: 'Filtros',
    offers: 'Ofertas',
    specialOffers: 'Ofertas especiais selecionadas para você',
    findBestProducts: 'Encontre os melhores produtos para você',
    priceRange: 'Faixa de Preço',
    colors: 'Cores',
    sizes: 'Tamanhos',
    sortByName: 'Nome',
    lowToHigh: 'Menor para Maior',
    highToLow: 'Maior para Menor',
    tryDifferentFilters: 'Tente ajustar seus filtros',
    clearFilters: 'Limpar Filtros',
    catalogDescription: 'Catálogo completo de produtos de qualidade',
    remaining: 'restantes',
    
    // Wholesale
    wholesale: 'Atacado',
    wholesaleTitle: 'Compras no Atacado',
    wholesaleDesc: 'Preços especiais para compras em grande quantidade',
    
    // Additional keys
    upTo: 'em até',
    goTo: 'Ir para',
    exploreCollection: 'Explore Nossa Coleção Completa',
    moreProductsAvailable: 'Mais de 1.000 produtos disponíveis com os melhores preços',
    footerText: 'Sua loja online de confiança com os melhores produtos e preços imbatíveis.',
    
    // Auth (additional)
    loginSuccess: 'Login realizado com sucesso',
    welcomeBack: 'Bem-vindo(a) de volta!',
    loginFailed: 'Falha no login. Verifique suas credenciais.',
    passwordsDoNotMatch: 'As senhas não coincidem',
    registrationSuccess: 'Cadastro realizado com sucesso!',
    accountCreatedSuccessfully: 'Conta criada com sucesso!',
    registrationFailed: 'Falha no cadastro. Tente novamente.',
    loginToPurchase: 'Entre para comprar',
    loginToContinue: 'Entre para continuar',
    loginToAccessAccount: 'Entre para acessar sua conta',
    username: 'Nome de usuário',
    enterUsername: 'Digite seu nome de usuário',
    enterPassword: 'Digite sua senha',
    loggingIn: 'Entrando...',
    creatingAccount: 'Criando conta...',
    dontHaveAccount: 'Não tem uma conta?',
    alreadyHaveAccount: 'Já tem uma conta?',
    loginPage: 'Página de Login',
    registerPage: 'Página de Cadastro',

    // Products (additional)
    freeShipping: 'Frete Grátis',
    addedToWishlist: 'Adicionado à lista de desejos',
    alreadyInWishlist: 'Já está na lista de desejos',
    errorAddingToWishlist: 'Erro ao adicionar à lista de desejos',
    adjustFilters: 'Tente ajustar seus filtros',
    free: 'Grátis',
    quickView: 'Visualização Rápida',
    errorWishlist: 'Erro na lista de desejos',
    addedToCart: 'Adicionado ao Carrinho',

    // Features (additional)
    flexiblePaymentDesc: 'Parcelamento em até 12x sem juros',
    readyToShop: 'Pronto para comprar?',
    joinCustomers: 'Junte-se a milhares de clientes satisfeitos',

    // Dashboard / Mobile
    menu: 'Menu',
    orders: 'Pedidos',
    quickActions: 'Ações Rápidas',
    dashboard: 'Painel',
    profile: 'Perfil',
    payment: 'Pagamento',

    // Currency & Exchange
    realTimeRate: 'câmbio em tempo real',
    exchangeRate: 'Taxa de Câmbio',
    cotacao: 'Cotação',
    
    // Product Detail additional
    freeShippingLabel: 'Frete GRÁTIS',
    decidedInWhatsApp: 'Será decidido no WhatsApp',
    onlyLeft: 'Só restam',
    maximum: 'Máximo',
    units: 'unidades',
    shareProduct: 'Compartilhe este produto',
    relatedProducts: 'Produtos Relacionados',
    variant: 'Variante',
    
    // Product Detail toast messages
    productOutOfStock: 'Este produto está esgotado no momento.',
    onlyXAvailable: 'Apenas {qty} disponíveis em estoque.',
    maxUnitsPerCart: 'Máximo {qty} unidades por carrinho.',
    pleaseSelectColor: 'Por favor selecione uma cor.',
    colorOutOfStock: 'Cor esgotada. Escolha outra.',
    onlyXInStockForColor: 'Apenas {qty} em estoque para "{item}".',
    pleaseSelectSize: 'Por favor selecione {label}.',
    sizeOutOfStock: '{label} esgotado. Escolha outro.',
    onlyXInStockForSize: 'Apenas {qty} em estoque para "{item}".',
    combinationNotAvailable: 'Esta combinação não está disponível.',
    variantOutOfStock: 'Esta variante está esgotada.',
    clickToDeselect: 'Clique para desmarcar',
    viewImage: 'Vista',
  },
  'es-PY': {
    // Navigation
    home: 'Inicio',
    products: 'Productos',
    categories: 'Categorías',
    about: 'Sobre Nosotros',
    contact: 'Contacto',
    cart: 'Carrito',
    account: 'Mi Cuenta',
    login: 'Iniciar Sesión',
    register: 'Registrarse',
    logout: 'Cerrar Sesión',
    search: 'Buscar',
    searchPlaceholder: 'Buscar productos, marcas, categorías...',
    
    // Header
    followUs: 'Síguenos',
    
    // Hero Section
    heroTitle: 'Descubrí productos increíbles',
    heroSubtitle: 'Comprá las últimas tendencias y ofertas exclusivas en un solo lugar.',
    shopNow: 'Comprar ahora',
    exploreCategories: 'Explorar Categorías',
    
    // Categories
    allCategories: 'Ver todas las categorías',
    showAllCategories: 'Ver todas las categorías',
    exploreSelection: 'Explorá la selección',
    viewProducts: 'Ver productos',
    
    // Products
    offersOfTheDay: 'Ofertas del Día',
    takeAdvantage: '¡Aprovechá los mejores descuentos de hoy!',
    mostViewed: 'Más Vistos',
    trendingNow: 'Estos productos son tendencia ahora mismo',
    viewAll: 'Ver Todo',
    viewAllProducts: 'Ver Todos los Productos',
    topBrands: 'Marcas Destacadas',
    showAll: 'Ver todas',
    showAllBrands: 'Ver todas las marcas',
    bestSellers: 'Más Vendidos',
    discoverBuying: 'Descubrí lo que están comprando ahora',
    featuredProducts: 'Productos Destacados',
    popularProducts: 'Productos Populares',
    specialSelection: 'Una selección especial para vos',
    discoverPopular: 'Descubrí nuestros productos más elegidos',
    mostRelevant: 'Más Relevante',
    lowestPrice: 'Menor Precio',
    highestPrice: 'Mayor Precio',
    newest: 'Más Reciente',
    newArrivals: 'Novedades',
    addToCart: 'Agregar al Carrito',
    buyNow: 'Comprar Ahora',
    inStock: 'En stock',
    outOfStock: 'Sin stock',
    price: 'Precio',
    quantity: 'Cantidad',
    color: 'Color',
    size: 'Tamaño',
    description: 'Descripción',
    specifications: 'Especificaciones',
    availability: 'Disponibilidad',
    category: 'Categoría',
    noSpecifications: 'No hay especificaciones disponibles',
    reviews: 'Reseñas',
    
    // Cart
    myCart: 'Mi Carrito',
    emptyCart: 'Tu carrito está vacío',
    continueShopping: 'Continuar Comprando',
    checkout: 'Finalizar Compra',
    subtotal: 'Subtotal',
    shipping: 'Envío',
    total: 'Total',
    removeItem: 'Eliminar',
    updateQuantity: 'Actualizar Cantidad',
    
    // Checkout
    shippingInfo: 'Información de Envío',
    fullName: 'Nombre Completo',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    address: 'Dirección',
    city: 'Ciudad',
    state: 'Departamento',
    country: 'País',
    zipCode: 'Código Postal',
    paymentMethod: 'Método de Pago',
    placeOrder: 'Realizar Pedido',
    
    // Account
    myAccount: 'Mi Cuenta',
    myOrders: 'Mis Pedidos',
    wishlist: 'Lista de Deseos',
    favorites: 'Favoritos',
    notifications: 'Notificaciones',
    settings: 'Configuración',
    orderHistory: 'Historial de Pedidos',
    
    // Auth
    emailAddress: 'Dirección de Correo Electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    noAccount: '¿No tenés una cuenta?',
    haveAccount: '¿Ya tenés una cuenta?',
    createAccount: 'Crear Cuenta',
    signIn: 'Iniciar Sesión',
    signUp: 'Registrarse',
    processing: 'Procesando...',
    
    // Contact
    contactUs: 'Contactanos',
    ourTeam: 'Nuestro Equipo',
    contactDirectly: 'Contactá directamente con quien pueda ayudarte mejor',
    generalManager: 'Director General',
    customerService: 'Atención al Cliente',
    salesAdvisory: 'Ventas y Asesoría',
    writeWhatsApp: 'Escribir por WhatsApp',
    contactInfo: 'Información de Contacto',
    sendMessage: 'Enviar Mensaje',
    yourName: 'Tu Nombre',
    yourEmail: 'Tu Correo',
    subject: 'Asunto',
    message: 'Mensaje',
    send: 'Enviar',
    
    // Vendedores
    vendedores: 'Vendedores',
    vendedoresDesc: 'Contacta a nuestros vendedores para una atención personalizada',
    messageOnWhatsApp: 'Mensaje en WhatsApp',

    // About
    aboutUs: 'Sobre Nosotros',
    ourMission: 'Nuestra Misión',
    ourValues: 'Nuestros Valores',
    ourHistory: 'Nuestra Historia',
    whyChooseUs: '¿Por qué elegir ASMAR SHOP?',
    bestOption: 'Somos tu mejor opción en productos y equipamiento',
    fastDelivery: 'Entrega Rápida',
    fastDeliveryDesc: 'Entregamos en todo Paraguay con rapidez y seguridad garantizada',
    qualityGuarantee: 'Garantía de Calidad',
    qualityGuaranteeDesc: 'Productos originales con garantía y respaldo oficial',
    personalizedService: 'Atención Personalizada',
    personalizedServiceDesc: 'Asesoría experta vía WhatsApp cuando la necesites',
    
    // Footer
    navigation: 'Navegación',
    newsletter: 'Newsletter',
    newsletterText: 'Recibí ofertas exclusivas y novedades primero.',
    yourEmailAddress: 'Tu correo electrónico',
    subscribeSuccess: '¡Inscripción exitosa!',
    noSpam: '¡Prometemos no enviar spam!',
    privacy: 'Privacidad',
    terms: 'Términos',
    paymentMethods: 'Formas de Pago',
    allRightsReserved: 'Todos los derechos reservados.',
    deliveryInfo: 'Información de Entrega',
    paraguayOnlyDelivery: 'ENTREGAS SOLO EN PARAGUAY',
    brazilPickupNotice: 'Entregas solo en Paraguay. Para Brasil y región, debe ser retirado en la tienda.',
    
    // FAQ
    faq: 'Preguntas Frecuentes',
    
    // Features
    qualityGuarantee: 'Garantía de Calidad',
    qualityGuaranteeDesc: 'Productos originales con garantía y soporte oficial',
    securePayment: 'Pago Seguro',
    securePaymentDesc: 'Comprá con total seguridad y protección',
    bestPrices: 'Mejores Precios',
    bestPricesDesc: 'Los mejores precios de Brasil y Paraguay',
    support24: 'Soporte 24/7',
    support24Desc: 'Atención siempre disponible para vos',
    fastDelivery: 'Entrega Rápida',
    fastDeliveryDesc: 'Flete será decidido en el checkout',
    easyReturns: 'Devolución Fácil',
    easyReturnsDesc: 'Hasta 30 días para devolver',
    
    // General
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    seeAll: 'Ver todo',
    seeMore: 'Ver más',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    filter: 'Filtrar',
    sort: 'Ordenar',
    apply: 'Aplicar',
    clear: 'Limpiar',
    clearAll: 'Limpiar todo',
    noResults: 'No se encontraron resultados',
    continue: 'Continuar',
    
    // Search
    searchProducts: 'Buscar Productos',
    productsFound: 'productos encontrados',
    results: 'resultados',
    all: 'Todos',
    noResultsFor: 'No se encontraron resultados para',
    noProductsFound: 'No se encontraron productos',
    tryAdjustingFilters: 'Intenta ajustar los filtros o buscar otro término',
    errorSearching: 'Error al buscar',
    errorAddingToCart: 'Error al agregar al carrito',
    
    or: 'o',
    items: 'artículos',
    
    // Cart Additional
    cartItems: 'Artículos del Carrito',
    orderSummary: 'Resumen del Pedido',

    itemRemoved: 'Artículo eliminado',
    deleteError: 'Error al eliminar',
    updateError: 'Error al actualizar',
    addItemsToCart: 'Agregá productos a tu carrito',
    enterFullName: 'Ingresá tu nombre completo',
    enterEmail: 'Ingresá tu correo',
    enterPhone: 'Ingresá tu teléfono',
    enterAddress: 'Ingresá tu dirección',
    enterCity: 'Ingresá tu ciudad',
    enterState: 'Ingresá tu departamento',
    loginRequired: 'Inicio de Sesión Requerido',
    loginToCheckout: 'Iniciá sesión para continuar',
    loginToAddWishlist: 'Por favor iniciá sesión para agregar a favoritos.',
    requiredFields: 'Campos Requeridos',
    fillAllFields: 'Completá todos los campos',
    orderPlaced: '¡Pedido Realizado!',
    orderError: 'Error al crear pedido',
    orderViaWhatsApp: 'Pedir por WhatsApp',
    proceedToPayment: 'Ir al Pago',
    order: 'Pedido',
    customerData: 'Datos del Cliente',
    shippingAddress: 'Dirección de Entrega',
    orderSuccess: '¡Pedido creado exitosamente!',
    
    // Products Page (additional keys not already defined)
    filters: 'Filtros',
    offers: 'Ofertas',
    specialOffers: 'Ofertas especiales seleccionadas para vos',
    findBestProducts: 'Encontrá los mejores productos para vos',
    priceRange: 'Rango de Precios',
    colors: 'Colores',
    sizes: 'Tamanhos',
    sortByName: 'Nombre',
    lowToHigh: 'Menor a Mayor',
    highToLow: 'Mayor a Menor',
    tryDifferentFilters: 'Intentá ajustar tus filtros',
    clearFilters: 'Limpiar Filtros',
    catalogDescription: 'Catálogo completo de productos de calidad',
    remaining: 'restantes',
    
    // Wholesale
    wholesale: 'Por Mayor',
    wholesaleTitle: 'Compras al Por Mayor',
    wholesaleDesc: 'Precios especiales para compras en grandes cantidades',
    
    // Additional keys
    upTo: 'hasta',
    goTo: 'Ir a',
    exploreCollection: 'Explorá Nuestra Colección Completa',
    moreProductsAvailable: 'Más de 1.000 productos disponibles con los mejores precios',
    footerText: 'Tu tienda online de confianza con los mejores productos y precios imbatibles.',
    
    // Auth (additional)
    loginSuccess: 'Inicio de sesión exitoso',
    welcomeBack: '¡Bienvenido(a) de vuelta!',
    loginFailed: 'Inicio de sesión fallido. Verificá tus credenciales.',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    registrationSuccess: '¡Registro exitoso!',
    accountCreatedSuccessfully: '¡Cuenta creada exitosamente!',
    registrationFailed: 'Error en el registro. Intentá de nuevo.',
    loginToPurchase: 'Iniciá sesión para comprar',
    loginToContinue: 'Iniciá sesión para continuar',
    loginToAccessAccount: 'Iniciá sesión para acceder a tu cuenta',
    username: 'Nombre de usuario',
    enterUsername: 'Ingresá tu nombre de usuario',
    enterPassword: 'Ingresá tu contraseña',
    loggingIn: 'Iniciando sesión...',
    creatingAccount: 'Creando cuenta...',
    dontHaveAccount: '¿No tenés una cuenta?',
    alreadyHaveAccount: '¿Ya tenés una cuenta?',
    loginPage: 'Página de Inicio de Sesión',
    registerPage: 'Página de Registro',

    // Products (additional)
    freeShipping: 'Envío Gratis',
    addedToWishlist: 'Agregado a favoritos',
    alreadyInWishlist: 'Ya está en favoritos',
    errorAddingToWishlist: 'Error al agregar a favoritos',
    adjustFilters: 'Intentá ajustar tus filtros',
    free: 'Gratis',
    quickView: 'Vista Rápida',
    errorWishlist: 'Error en favoritos',
    addedToCart: 'Agregado al Carrito',

    // Features (additional)
    flexiblePaymentDesc: 'Hasta 12 cuotas sin interés',
    readyToShop: '¿Listo para comprar?',
    joinCustomers: 'Unite a miles de clientes satisfechos',

    // Dashboard / Mobile
    menu: 'Menú',
    orders: 'Pedidos',
    quickActions: 'Acciones Rápidas',
    dashboard: 'Panel',
    profile: 'Perfil',
    payment: 'Pago',

    // Currency & Exchange
    realTimeRate: 'cambio en tiempo real',
    exchangeRate: 'Tipo de Cambio',
    cotacao: 'Cotización',
    
    // Product Detail additional
    freeShippingLabel: 'Envío GRATIS',
    decidedInWhatsApp: 'Será decidido en WhatsApp',
    onlyLeft: '¡Solo quedan',
    maximum: 'Máximo',
    units: 'unidades',
    shareProduct: 'Compartí este producto',
    relatedProducts: 'Productos Relacionados',
    variant: 'Variante',
    
    // Product Detail toast messages
    productOutOfStock: 'Este producto está actualmente agotado.',
    onlyXAvailable: 'Solo {qty} disponibles en stock.',
    maxUnitsPerCart: 'Máximo {qty} unidades por carrito.',
    pleaseSelectColor: 'Por favor seleccioná un color.',
    colorOutOfStock: 'Color agotado. Elegí otro.',
    onlyXInStockForColor: 'Solo {qty} en stock para "{item}".',
    pleaseSelectSize: 'Por favor seleccioná {label}.',
    sizeOutOfStock: '{label} agotado. Elegí otro.',
    onlyXInStockForSize: 'Solo {qty} en stock para "{item}".',
    combinationNotAvailable: 'Esta combinación no está disponible.',
    variantOutOfStock: 'Esta variante está agotada.',
    clickToDeselect: 'Clic para deseleccionar',
    viewImage: 'Vista',
  }
};

const languages = [
  { 
    code: 'pt-BR', 
    name: 'Português', 
    country: 'Brasil', 
    flag: 'https://flagcdn.com/w40/br.png',
    flagEmoji: '🇧🇷'
  },
  { 
    code: 'es-PY', 
    name: 'Español', 
    country: 'Paraguay', 
    flag: 'https://flagcdn.com/w40/py.png',
    flagEmoji: '🇵🇾'
  }
];

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const saved = localStorage.getItem('asmarshop-language');
    return saved || 'pt-BR';
  });

  useEffect(() => {
    localStorage.setItem('asmarshop-language', currentLanguage);
    document.documentElement.lang = currentLanguage;
  }, [currentLanguage]);

  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode);
  };

  const t = (key) => {
    return translations[currentLanguage]?.[key] || translations['pt-BR']?.[key] || key;
  };

  const getCurrentLanguageData = () => {
    return languages.find(lang => lang.code === currentLanguage) || languages[0];
  };

  return (
    <LanguageContext.Provider value={{ 
      currentLanguage, 
      changeLanguage, 
      t, 
      languages,
      getCurrentLanguageData,
      translations: translations[currentLanguage]
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
